export default __webpack_public_path__ + "static/media/13.96640b97.jpg";